module.exports = __webpack_public_path__ + "static/storia_small-9795cb952544641183940e162d874a92.jpg";